import type { ReactNode } from "react";
import styles from "./page.module.css";

export function Page({
  children,
  width = "page",
}: {
  children: ReactNode;
  width?: "page" | "narrow";
}) {
  return (
    <div className={`${styles.page} ${width === "narrow" ? styles.narrow : ""}`}>{children}</div>
  );
}

export function PageHeader({
  title,
  description,
  action,
}: {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className={styles.header}>
      <div>
        <h1 className={styles.title}>{title}</h1>
        {description ? <div className={styles.description}>{description}</div> : null}
      </div>
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
}
